var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuex-table',{attrs:{"fields":_vm.fields,"filter_items":_vm.filter_items,"show_per_page":false,"auto_start":false,"foot_clone":true,"no_footer_sorting":true,"total_caption":"group_by","table_store":"voice/stats/general"}})}
var staticRenderFns = []

export { render, staticRenderFns }